module.exports = {
      id: "icon-election-usage",
      viewBox: "0 0 110 110",
      url: "/" + "sprite-bc0169963456b1a4ad1bb8f1c406f483.svg#icon-election",
      toString: function () {
        return this.url;
      }
    }